var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVideo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "14 15 22 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero",
    stroke: "none",
    strokeWidth: 0.2,
    transform: "translate(14 15)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "svg-path1",
    d: "M15.728 20H0V8.661h15.728V20zm-14.63-1.097H14.63V9.759H1.097v9.144z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "svg-path1",
    d: "M21.58 19.37l-6.95-3.393v-3.278l6.95-3.43V19.37zm-5.852-4.081l4.755 2.326v-6.584l-4.755 2.327v1.931z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "svg-path1",
    cx: 9.327,
    cy: 14.331,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    className: "svg-path1",
    cx: 6.401,
    cy: 14.331,
    r: 1
  }), /*#__PURE__*/React.createElement("path", {
    className: "svg-path1",
    d: "M3.475 6.95C1.555 6.95 0 5.394 0 3.475 0 1.555 1.556 0 3.475 0S6.95 1.556 6.95 3.475c-.004 1.917-1.558 3.47-3.475 3.475zm0-5.853c-1.313 0-2.378 1.065-2.378 2.378 0 1.313 1.065 2.377 2.378 2.377 1.313 0 2.377-1.064 2.377-2.377 0-.63-.25-1.236-.696-1.681-.446-.446-1.05-.697-1.681-.697zM11.522 6.95c-1.92 0-3.475-1.556-3.475-3.475C8.047 1.555 9.603 0 11.522 0s3.474 1.556 3.474 3.475c-.004 1.917-1.557 3.47-3.474 3.475zm0-5.853c-1.313 0-2.378 1.065-2.378 2.378 0 1.313 1.065 2.377 2.378 2.377 1.313 0 2.377-1.064 2.377-2.377 0-.63-.25-1.236-.696-1.681-.446-.446-1.05-.697-1.681-.697z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVideo);
export default __webpack_public_path__ + "static/media/video.73aeb9287a4cd971517a2e5919d651d5.svg";
export { ForwardRef as ReactComponent };